export default "__VITE_ASSET__DUUH4dvY__"